var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#82AFFF"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M293.012,238.404V371.67c0,54.045,75.919,81.823,85.17,85.005c9.241-3.182,85.17-31.003,85.17-85.005  V238.404H293.012z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "466.357,299.526 466.357,235.398 290.006,235.398 290.006,299.526 366.158,299.526   366.158,359.646 290.006,359.646 290.006,383.694 366.158,383.694 366.158,455.837 378.182,459.845 390.206,455.837   390.206,383.694 466.357,383.694 466.357,359.646 390.206,359.646 390.206,299.526 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M318.066,268.518c5.965,9.911-4.356,20.231-14.267,14.267c-0.932-0.561-1.723-1.352-2.284-2.284  c-5.965-9.911,4.356-20.231,14.267-14.267C316.714,266.795,317.505,267.586,318.066,268.518z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M329.056,260.943c-3.211-1.766-8.991-6.502-11.319-5.699c-2.328,0.803-2.849,2.449-6.105,2.7   c-3.173,0.244-8.183,3.34-6.096,6.773c2.715,4.467,11.212,0.992,11.774-1.095c0,0,2.087,0.334,3.841-0.083   c0,0,3.49,4.871,7.825,4.55c4.335-0.321,6.342-5.699,5.378-5.699S329.056,260.943,329.056,260.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M342.382,282.216c-0.722,1.325-6.222,6.026-15.413,8.188c-2.047,0.482-1.686,2.89-3.733,1.686   s-7.706-2.167-12.764-2.408s-5.56-4.926-4.696-6.623c1.096-2.153,9.17-3.466,10.615-0.817c1.445,2.649,2.527,2.096,6.122,2.864   c2.228,0.476,2.288,1.565,2.288,1.565s4.094-4.094,7.586-5.298s6.502-3.853,7.104-3.853s3.733,0.843,3.733,0.843L342.382,282.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M355.748,268.007c5.298,1.927,20.952,1.325,37.689-4.094c16.737-5.418,21.554-6.382,29.742-3.371   c8.188,3.01,11.733-6.5,6.356-8.109c-8.447-2.528-34.569,12.65-53.482,4.133c0,0-0.557,2.29,0.045,3.374   c0,0-13.727,0.482-10.476-13.727c0,0,0.935,5.187,7.425,4.591c12.274-1.127,14.028,7.515,40.017-0.497   c14.429-4.448,25.639-2.265,25.739,4.756c0.12,8.451-11.53,10.416-11.53,10.416s4.535,9.272,13.687,5.178   c9.151-4.094,9.633,2.97,10.436,5.378s2.328,4.736,4.335,4.977c0,0,1.445,4.335,0.883,4.897s-4.335,5.298-8.108,5.298   s-11.961,0-11.961,0s-2.167-5.378,2.007-5.459c4.174-0.08,9.232-0.401,8.589-2.649c-0.642-2.248-3.933-3.291-3.853-5.78   c0,0-9.713,7.064-15.734-1.284l-0.161,3.933c0,0-7.305-1.365-9.954-7.225c0,0,0.722,6.582-5.539,5.619c0,0,1.284,1.927,3.452,3.291   c2.167,1.365-0.08,4.335-4.255,6.823s-17.018,9.713-22.878,2.328s1.284-11.64,3.05-11.158c1.766,0.482,6.823,8.268,10.275,7.225   c3.452-1.044,5.138-4.576,2.248-6.743c-2.89-2.167-5.055-4.217-3.232-6.404c2.505-3.006,11.741-2.105,11.42-4.112   c-0.321-2.007-8.91-1.445-14.53,4.174c-5.619,5.619-30.023,18.543-39.736,10.355C348.001,275.954,355.748,268.007,355.748,268.007z   "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD25A"
    },
    d: "M352.617,264.395c0,0,7.345,7.225,19.747,9.512c0,0-2.288,3.492-8.91,2.529  c0,0,2.649,2.288,4.455,6.141c0,0-4.214,0.963-7.947-1.084c0,0,0.482,3.131,2.288,5.659c0,0-4.937,0-9.151-3.733l-1.686,4.816  c0,0-2.89-1.927-4.696-5.659c0,0-3.371,2.649-6.743,2.649c0,0,1.204-3.612,1.204-5.659c0,0-4.816,2.89-8.79,1.806  c0,0,0.12-5.057,1.445-6.502c0,0-3.131,0.361-5.178-0.722c0,0,1.204-2.769,1.806-4.576c0,0-3.372,0.12-5.419-1.806  c0,0,6.502-2.529,7.947-4.937L352.617,264.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M340.776,244.166c1.445,0.803,3.773,2.569,4.736,5.539c0,0,2.649-3.853,7.225-4.576  c0,0,2.007,2.248,1.445,8.108c0,0,5.057-1.445,7.787,1.204c0,0-5.378,1.204-7.867,5.699c0,0-0.965,4.593,0.721,7.322  c0,0-1.879,0.251-3.771-0.579c0,0-0.963,4.576,0,6.021c0,0-2.649-0.321-4.094-3.131c0,0-2.167,3.291-2.007,5.298  c0,0-2.89-1.686-3.05-4.174c0,0-2.007,3.773-4.174,4.094c0,0-0.241-5.298-1.204-7.305c0,0-1.846,2.007-4.255,1.927  c0,0,0-4.094,2.007-6.021c0,0-3.371,1.044-5.218-2.649c0,0,5.539,1.605,6.904-1.766c1.365-3.372,1.766-4.415,3.693-6.261  C341.579,251.069,340.776,244.166,340.776,244.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M352.617,259.699c0,0-6.863,13.125-13.125,9.151c-6.86-4.354,1.686-14.57,2.769-15.653  C342.262,253.196,347.319,254.521,352.617,259.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M327.863,326.922c0,0-0.72-9.427-5.83-12.146c-4.806-2.557-7.642-3.836-8.194-7.112  c0,0,4.176,1.918,8.588,3.116c3.987,1.083,7.878,7.831,6.697,15.422L327.863,326.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M311.732,334.673l0.65,1.199l0.473,2.577l-0.945,3.056c0,0,3.754,1.493,4.609,6.592  c0.587,3.5,2.127,4.255,3.073,3.536c0.945-0.719,1.518-1.57,0.532-5.394c-1.259-4.882-4.668-9.529-4.668-9.529l-2.659-4.075  L311.732,334.673z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M315.455,336.71c-3.427-4.435-12.763-13.664-14.536-1.079c0,0-3.66-10.603,3.191-10.188   C312.027,325.923,315.455,336.71,315.455,336.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M312.382,335.871c-2.954-3.236-3.9-5.633-5.436-11.626s-2.009-7.791-3.782-7.671   s-2.836,2.038-2.836,5.873c0,0-5.2-4.675-1.654-8.39s11.463-1.678,11.936,4.914s0.355,11.027,2.718,16.541L312.382,335.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M313.209,332.995c0,0-6.263-13.784,11.345-21.215c0,0-15.599-4.195-13.709,17.979L313.209,332.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M315.218,337.909c0,0-13.236-5.034-12.054,7.192c0,0,2.245-5.753,8.745-3.596L315.218,337.909z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M330.227,333.075c0,3.576,1.406,13.951-0.591,15.262c-1.005,0.659-3.841,0.12-3.604-2.397  c0.236-2.517,1.359-14.743,1.359-17.739C327.39,325.204,330.227,333.075,330.227,333.075z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M321.797,341.385c2.285-2.317,2.994-7.591,2.206-14.623c0,0,4.727,3.276,6.224,6.313   c0,0,1.497-6.952-3.388-8.79s-7.485-0.799-8.351,1.438c-0.867,2.237,1.493,4.739,2.521,8.39   C321.954,337.47,321.797,341.385,321.797,341.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M329.912,331.237c0,0,0.788-3.676,3.388-5.194c0,0,5.357,3.756,4.963,8.79   c0,0,1.418-6.872-1.497-9.589s-6.224-3.436-7.878-1.039C327.233,326.602,329.912,331.237,329.912,331.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M331.172,324.205c0,0,1.654-9.829,5.83-11.986c4.176-2.157,11.896-4.155,12.369-4.635   c0,0-9.218,0.479-10.715,0.479s-9.769,5.993-9.769,14.863s0.788,2.797,1.024,2.717   C330.148,325.563,331.172,324.205,331.172,324.205z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M335.013,350.195c0.945,1.978,3.191,2.457,3.663,1.438c0.473-1.019,2.6-8.81,2.6-8.81l-3.014-1.438  L335.013,350.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M352.68,317.493c3.703-2.158,6.145,4.235,6.145,4.235c0-7.527-2.364-9.909-8.272-7.032  c-1.78,0.867-3.081,2.682-4.04,4.787c-2.992-8.594-9.589-8.463-9.589-8.463l-1.497,1.039c5.402,1.038,8.495,7.512,9.805,11.044  c-0.706,2.577-1.047,5.075-1.193,6.505c-3.54,3.67-5.775,11.776-5.775,11.776s2.541,1.498,3.014,1.438c0,0,1.654-5.094,3.723-4.974  c2.068,0.12,4.491,3.416,4.55,5.514c0,0,3.073-6.233-0.591-8.63c-1.376-0.901-2.477-1.242-3.366-1.259l2.716-3.056  c4.432,0.839,7.504,5.034,7.504,5.034c0.09-7.491-3.218-8.953-6.706-8.325C349.733,324.111,351.103,318.412,352.68,317.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M425.627,327.866c0,6.282,0,20.216,0,21.244s-4.499,5.025-4.499,5.025h11.961  c0,0-3.841-4.454-3.841-5.025s0.878-19.645,0.878-19.645L425.627,327.866z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M426.396,330.036c-2.853-0.228-10.754,6.282-13.058,16.218c0,0-7.023-11.421,10.535-20.901   c0,0-7.791-2.284-19.643,10.051c-0.64,0.666-1.207-18.617,20.082-13.477c0,0-8.12-11.764-24.8-2.513   c0,0,11.083-19.873,27.434-2.056c0,0,0.11-15.419,0.219-13.82c0.11,1.599,1.317,8.68,1.317,8.68l3.182-5.596l-2.524,11.421   c0,0,14.595-19.416,26.995,0.799c0,0-16.021-6.624-23.703,0.799c0,0,16.46-4.454,15.143,14.619c0,0-6.474-11.307-17.009-9.822   c0,0,12.4,5.711,8.45,21.129C439.015,345.569,431.543,330.448,426.396,330.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M321.605,398.675c-0.611-0.828-1.467-1.225-2.307-1.328c0.323-1.114,0.538-1.623,0.452-2.434   c0.257,0.064,0.501,0.179,0.764,0.21l0.112-0.917c-0.975-0.117-2.036-0.554-3.128-1.22c0.673-0.578,1.16-1.462,1.16-2.547   c0-1.179-0.541-2.166-1.31-2.727c-0.769,0.561-1.31,1.548-1.31,2.727c0,0.886,0.362,1.594,0.84,2.164   c-0.406-0.281-0.816-0.606-1.227-0.955c-0.107-0.725-0.384-1.455-1.028-2.042c-0.872-0.794-1.965-1.059-2.898-0.869   c-0.103,0.946,0.262,2.011,1.134,2.805c0.672,0.613,1.464,0.823,2.225,0.839c0.173,0.147,0.355,0.295,0.547,0.444   c-0.522-0.063-1.086-0.009-1.649,0.196c-1.108,0.403-1.85,1.249-2.115,2.163c0.791,0.53,1.903,0.701,3.011,0.298   c0.966-0.352,1.59-1.061,1.925-1.838c0.649,0.415,1.36,0.759,2.096,1.035l-0.117,0.015c-0.024,0.665,0.019,0.938-0.311,2.174   c-0.744-0.482-1.73-0.7-2.771-0.393c-1.131,0.333-1.925,1.13-2.246,2.026c0.755,0.579,1.855,0.819,2.986,0.486   c0.849-0.25,1.427-0.798,1.838-1.417c-0.155,0.469-0.351,0.954-0.57,1.447c-0.665,0.307-1.288,0.78-1.669,1.563   c-0.516,1.06-0.461,2.184-0.016,3.025c0.937-0.168,1.855-0.819,2.371-1.88c0.398-0.818,0.376-1.637,0.177-2.372   c0.092-0.208,0.182-0.424,0.272-0.65c0.087,0.519,0.298,1.044,0.653,1.526c0.7,0.949,1.721,1.422,2.673,1.418   C322.455,400.739,322.305,399.624,321.605,398.675z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFECDE"
    },
    d: "M316.183,395.714c4.006,0,9.244-0.154,9.09,3.852c-0.154,4.006-4.622,17.564,5.701,21.724  s11.555,3.544,11.555,3.544l4.622,10.631l11.247-4.006l-10.785-8.628c0,0-0.924-5.855-3.544-9.86c0,0,6.625-3.389,8.936-6.317  l-4.622-0.308c0,0,6.009-3.852,8.782-8.166l-3.235,0.308c0,0,3.698-3.698,4.622-8.012c0,0-6.009,6.009-12.171,6.779  c0,0,2.619-6.779,3.235-9.398c0,0-4.622,2.927-7.857,4.16s-8.32,1.387-6.009,11.863c0,0-2.773-2.311-4.468-7.241  c-1.695-4.93-2.311-6.779-4.622-6.779c-3.775,0-5.238,3.389-5.238,3.389L316.183,395.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M429.893,397.695c1.386-1.848,4.158-7.623,6.583-6.121c2.425,1.501,5.659,5.197,7.623,3.465  c1.963-1.732,2.079-3.927-0.924-4.966c-3.003-1.039-6.352-2.772-8.431-2.079s-8.431,7.276-8.431,7.276L429.893,397.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M411.991,402.661c-0.115-2.656,1.677-14.19,8.893-12.704c3.927,0.808,5.858,4.971,10.972,6.93  c5.428,2.079,8.893,3.349,7.854,6.93c-1.039,3.58-3.003,7.854-7.507,8.893C427.699,413.749,411.991,402.661,411.991,402.661z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M407.256,412.17c-1.54,0.308-7.238,8.624-0.462,17.093c0,0,8.316,3.388,14.937-1.848   s1.694-7.854,1.694-7.854L407.256,412.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ABEA0"
    },
    d: "M407.834,413.98c-0.693-1.039-0.577-1.809-0.577-1.809s-0.346-11.934,4.62-12.165   c4.966-0.231,22.868,11.549,22.868,13.513c0,1.963-5.775,7.623-10.625,8.778S407.834,413.98,407.834,413.98z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M395.591,442.853c0,0,15.775-7.087,12.81-12.853c-2.14-4.16-6.95-1.494-7.71,1.682  C399.743,435.646,396.659,441.171,395.591,442.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M378.182,463l-0.912-0.29c-0.916-0.294-22.694-7.308-44.83-21.899  c-29.727-19.59-45.44-43.5-45.44-69.141V232.392h182.363V371.67c0,25.641-15.713,49.552-45.44,69.142  c-22.136,14.592-43.914,21.606-44.83,21.899L378.182,463z M293.012,238.404V371.67c0,54.045,75.919,81.823,85.17,85.005  c9.241-3.182,85.17-31.003,85.17-85.005V238.404H293.012z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0 0,0 0,19.977 94.316,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.299 0,94.316 39.71,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.684 0,187.701 39.71,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,19.977 256,0 161.684,0 161.684,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.701 256,161.684 216.29,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.23 161.684,256 256,256 256,236.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.316 256,68.299 216.29,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.023 0,256 94.316,256 94.316,174.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.023 256,216.059 172.232,161.684 196.98,161.684 256,199.995 256,187.701    216.29,161.684 256,161.684 256,148.21 148.211,148.21 148.211,256 161.684,256 161.684,174.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.21 0,161.684 39.71,161.684 0,187.701 0,206.602 69.197,161.684 93.945,161.684    0,222.666 0,236.023 94.316,174.23 94.316,256 107.789,256 107.789,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0 94.316,0 94.316,81.77 0,19.977 0,41.839 80.842,94.316 56.094,94.316 0,57.904    0,68.299 39.71,94.316 0,94.316 0,107.79 107.789,107.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.79 256,94.316 216.29,94.316 256,68.299 256,49.157 186.432,94.316 161.684,94.316    256,33.093 256,19.977 161.684,81.77 161.684,0 148.211,0 148.211,107.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.21 256,107.79 148.211,107.79 148.211,0 107.789,0 107.789,107.79 0,107.79    0,148.21 107.789,148.21 107.789,256 148.211,256 148.211,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.684 0,206.602 0,222.666 93.945,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.684 256,216.059 256,199.995 196.98,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.316 0,41.839 0,57.904 56.094,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.316 256,49.157 256,33.093 161.684,94.316  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFj);
export default __webpack_public_path__ + "static/media/fj.9441a44489695f2fe1ebf7220cbe41a2.svg";
export { ForwardRef as ReactComponent };